import React from 'react';
import invariant from 'tiny-invariant';
import { createMediaQuery } from './create-media-query';
import { observeMediaQuery } from './observe-media-query';
import { isBrowser } from '../../utils';
export const useMediaQueryListener = (query, cb, params = {}) => {
  const cbRef = React.useRef(cb);
  const paramsRef = React.useRef(params);
  const supportsMatchMedia = React.useRef(isBrowser() && 'matchMedia' in window);
  const parsedMediaQuery = createMediaQuery(query);
  React.useEffect(() => {
    cbRef.current = cb;
  }, [cb]);
  React.useEffect(() => {
    paramsRef.current = params;
  }, [params]);
  React.useEffect(() => {
    if (!supportsMatchMedia.current && isBrowser()) {
      invariant(false, "matchMedia isn't supported in your browser\n" + 'Please, use related polyfill or different implementations');
      return () => {};
    }
    const {
      triggerImmediate = false
    } = paramsRef.current;
    const matchMedia = window.matchMedia(parsedMediaQuery);
    const unsub = observeMediaQuery(matchMedia, cbRef.current);
    if (triggerImmediate) cbRef.current(matchMedia, unsub);
    return unsub;
  }, [parsedMediaQuery]);
};